// Ganzzahl mit deutschem Tausenderpunkt. Nicht-endliche oder negative Werte -> '0' (nie eine Exception).
export function formatInt(n: number): string {
  if (typeof n !== 'number' || !Number.isFinite(n) || n < 0) return '0'
  return Math.round(n).toLocaleString('de-DE')
}
